// src/components/Admin/ChatManager/ChatCategoryManager.jsx
import { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { fetchChatCategories } from '../../../api/admin';
import CategoryList from './Category/CategoryList';
import CategoryForm from './Category/CategoryForm';
import { useCategory } from '../../../contexts/CategoryContext';   // ★ 사이드바 갱신용

const ChatCategoryManager = () => {
    /* ── Context: 사이드바 동기화 ───────────────────────────── */
    const { reloadCategories } = useCategory();        // ★

    /* ── Local state ────────────────────────────────────────── */
    const [categories, setCategories] = useState([]);
    const [openForm, setOpenForm] = useState(false);
    const [currentCat, setCurrentCat] = useState(null);
    const [isEdit, setIsEdit] = useState(false);

    /* ── API 호출: 관리자 테이블용 ──────────────────────────── */
    const loadCategories = useCallback(() => {
        fetchChatCategories()
            .then(res => {
                // ★ order 기준으로 정렬
                const sorted = [...(res.data.categories ?? [])]
                    .sort((a, b) => a.order - b.order);
                setCategories(sorted);
            })
            .catch(() => setCategories([]));
    }, []);

    /* 첫 마운트 시 1회 실행 */
    useEffect(() => {
        loadCategories();
    }, [loadCategories]);

    /* 공통 후처리: 테이블 + 사이드바 갱신 */
    const handleAfterChange = () => {
        loadCategories();       // 관리자 표 새로고침
        reloadCategories();     // ★ 사이드바 실시간 갱신
    };

    /* ── UI 이벤트 ──────────────────────────────────────────── */
    const handleAdd = () => {
        setCurrentCat(null);
        setIsEdit(false);
        setOpenForm(true);
    };

    const handleEdit = (cat) => {
        setCurrentCat(cat);
        setIsEdit(true);
        setOpenForm(true);
    };

    /* ── Render ────────────────────────────────────────────── */
    return (
        <Box sx={{ p: 4, '@media (max-width:600px)': { p: 2 } }}>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ '@media (max-width:600px)': { fontSize: '1.2rem' } }}
            >
                채팅 카테고리 관리
            </Typography>

            <Button
                variant="contained"
                onClick={handleAdd}
                sx={{ mb: 2, '@media (max-width:600px)': { width: '100%', fontSize: '0.9rem' } }}
            >
                ➕ 카테고리 추가
            </Button>

            <CategoryList
                categories={categories}
                onEdit={handleEdit}
                reload={handleAfterChange}          /* 관리자 테이블 갱신 */
                reloadCategories={reloadCategories} /* ★ 사이드바 갱신 */
            />

            {openForm && (
                <CategoryForm
                    open={openForm}
                    onClose={() => setOpenForm(false)}
                    category={currentCat}
                    isEdit={isEdit}
                    reload={handleAfterChange}        /* 테이블 갱신 */
                    reloadCategories={reloadCategories} /* ★ 사이드바 갱신 */
                />
            )}
        </Box>
    );
};

export default ChatCategoryManager;
